<div class="profile">
  <h1 class="headline">PROFILE</h1>
  <hr class="mb-2" />
  <div class="row mt-3">
    @if (userHasNocOrSocNotificationsAllowed) {
      <div class="noc-soc-layout">
        <user-info
          class="user-info"
          [userFullName]="userFullName"
          [email]="user?.email"
          [isGlobalAdmin]="isGlobalAdmin"
          [hasRbacV2Roles]="hasRbacV2Roles"
          [companyEnabledServices]="companyEnabledServices"
          [accessDataLength]="accessItemCount"
          [joinedAccessData]="joinedAccessData"
          [phone]="user?.phone"
        ></user-info>
        <mat-card appearance="outlined" class="px-3 profile-card mb-3">
          <notification-preferences
            class="notification-preferences"
            [notificationSettings]="notificationSettings"
            [isLoading]="isLoadingNotificationUpdate || isLoadingNotificationPreferences"
            [isNocAllowed]="isNocAllowed"
            [isSocAllowed]="isSocAllowed"
            [isSpsAllowed]="isSpsAllowed"
            (onSaveNotificationPreferences)="saveNotificationPreferences($event)"
          >
          </notification-preferences>
        </mat-card>
        <company-info
          class="company-info"
          [companyDescription]="companyData?.description"
          [companyEnabledServices]="companyEnabledServices"
          [companyDataExists]="companyData !== null"
        ></company-info>
      </div>
    } @else {
      <div class="col-lg-6">
        <user-info
          [userFullName]="userFullName"
          [email]="user?.email"
          [isGlobalAdmin]="isGlobalAdmin"
          [hasRbacV2Roles]="hasRbacV2Roles"
          [companyEnabledServices]="companyEnabledServices"
          [accessDataLength]="accessItemCount"
          [joinedAccessData]="joinedAccessData"
          [phone]="user?.phone"
        ></user-info>
      </div>
      <div class="col-lg-6">
        <company-info
          [companyDescription]="companyData?.description"
          [companyEnabledServices]="companyEnabledServices"
          [companyDataExists]="companyData !== null"
        ></company-info>
      </div>
    }
  </div>
</div>
